import * as types from './types';

const initialState = {
  loading: false,
  mensajeErrorLoading: null,
  list: null,
  totalItems: 0,
  item: null,
  updating: false,
  mensajeErrorUpdating: null,
  updateSuccess: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_AUTORIZACIONES_LIST_START:
      return {
        ...state,
        mensajeErrorLoading: null,
        loading: true,
        updateSuccess: false,
      };
    case types.GET_AUTORIZACION_START:
    case types.CREATE_AUTORIZACION_START:
    case types.UPDATE_AUTORIZACION_START:
    case types.DELETE_AUTORIZACION_START:
      return {
        ...state,
        mensajeErrorUpdating: null,
        updateSuccess: false,
        updating: true,
      };
    case types.GET_AUTORIZACIONES_LIST_ERROR:
      return {
        ...state,
        loading: false,
        mensajeErrorLoading: payload,
      };
    case types.GET_AUTORIZACION_ERROR:
    case types.CREATE_AUTORIZACION_ERROR:
    case types.UPDATE_AUTORIZACION_ERROR:
    case types.DELETE_AUTORIZACION_ERROR:
      return {
        ...state,
        updating: false,
        updateSuccess: false,
        mensajeErrorUpdating: payload,
      };
    case types.GET_AUTORIZACIONES_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: payload.data,
        totalItems: parseInt(payload.headers['x-total-count'], 10),
      };
    case types.GET_AUTORIZACION_SUCCESS:
    case types.CREATE_AUTORIZACION_SUCCESS:
    case types.UPDATE_AUTORIZACION_SUCCESS:
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        item: payload.data,
      };
    case types.DELETE_AUTORIZACION_SUCCESS:
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        item: initialState.paciente,
      };
    case types.RESET:
      return {
        ...initialState,
      };
    case types.RESET_AUTORIZACION:
      return {
        ...state,
        item: initialState.paciente,
      };
    default:
      return state;
  }
};
